var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"scroll",attrs:{"id":"cycle-list"}},[_vm._l((_vm.combinedCycles),function(cycle,index){return _c('CycleListItem',{key:index,attrs:{"isSelected":_vm.selectedCycle?._id == cycle._id,"cycle":cycle}})}),(_vm.newCycleCreation)?_c('div',{ref:"newCreationItem"},[_c('CreationCycleListItem',{attrs:{"zones":_vm.zones}})],1):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }